/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pct_hub_ex4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`45 is what percent of 180? (45 ÷ 180) × 100 = 25%.`)
};

const es_pct_hub_ex4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Qué porcentaje de 180 es 45? (45 ÷ 180) × 100 = 25%.`)
};

const de_pct_hub_ex4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`45 sind wie viel Prozent von 180? (45 ÷ 180) × 100 = 25%.`)
};

const nl_pct_hub_ex4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`45 is welk percentage van 180? (45 ÷ 180) × 100 = 25%.`)
};

const fr_pct_hub_ex4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`45 représente quel pourcentage de 180 ? (45 ÷ 180) × 100 = 25 %.`)
};

const it_pct_hub_ex4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`45 è quale percentuale di 180? (45 ÷ 180) × 100 = 25%.`)
};

const pt_br2_pct_hub_ex4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`45 é que porcentagem de 180? (45 ÷ 180) × 100 = 25%.`)
};

const pt_pct_hub_ex4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`45 é que percentagem de 180? (45 ÷ 180) × 100 = 25%.`)
};

const ja_pct_hub_ex4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`45は180の何パーセント？ (45 ÷ 180) × 100 = 25%。`)
};

const zh_pct_hub_ex4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`45 是 180 的百分之几？(45 ÷ 180) × 100 = 25%。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pct_hub_ex4 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pct_hub_ex4(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pct_hub_ex4", locale)
	if (locale === "en") return en_pct_hub_ex4(inputs)
	if (locale === "es") return es_pct_hub_ex4(inputs)
	if (locale === "de") return de_pct_hub_ex4(inputs)
	if (locale === "nl") return nl_pct_hub_ex4(inputs)
	if (locale === "fr") return fr_pct_hub_ex4(inputs)
	if (locale === "it") return it_pct_hub_ex4(inputs)
	if (locale === "pt-BR") return pt_br2_pct_hub_ex4(inputs)
	if (locale === "pt") return pt_pct_hub_ex4(inputs)
	if (locale === "ja") return ja_pct_hub_ex4(inputs)
	return zh_pct_hub_ex4(inputs)
};